/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import type { ImgHTMLAttributes } from 'react';
import { useQubeproMediaPreviewUrl, type DmsMediaUrlOptions } from '../../dms';

export interface QubeproMediaImgProps {
  stored: string | null | undefined;
  alt: string;
  className?: string;
  onError?: ImgHTMLAttributes<HTMLImageElement>['onError'];
  companyScope?: DmsMediaUrlOptions['companyScope'];
  systemMedia?: boolean;
}

export function QubeproMediaImg({ stored, alt, className, onError, companyScope, systemMedia = false }: QubeproMediaImgProps) {
  const { displayUrl, resolving } = useQubeproMediaPreviewUrl(stored, {
    companyScope,
    systemMedia,
  });
  if (!stored?.trim()) return null;
  if (!displayUrl && resolving) {
    return <span className={className} aria-hidden style={{ opacity: 0.4 }} />;
  }
  if (!displayUrl) return null;
  return <img src={displayUrl} alt={alt} className={className} onError={onError} />;
}
